import styled from 'styled-components/macro';

export const InputWrapper = styled.div`
  box-sizing: border-box;

  position: relative;
`;
